// Translations for LëtzServices
export const translations = {
  fr: {
    // Navigation
    nav_announcements: "Annonces",
    nav_how_it_works: "Comment ça marche",
    nav_services: "Services",
    nav_marketplace: "LëtzVerkafen",
    nav_dashboard: "Tableau de bord",
    nav_messages: "Messages",
    nav_login: "Se connecter",
    nav_create_account: "Créer un compte",
    nav_logout: "Déconnexion",
    nav_profile: "Mon profil",
    nav_view_profile: "Voir mon profil",
    nav_favorites: "Favoris",
    nav_pending_ratings: "Notations en attente",
    nav_create_post: "Créer une annonce",
    nav_menu: "Menu",
    bottom_nav_home: "Accueil",
    bottom_nav_listings: "Annonces",
    bottom_nav_create: "Créer",
    bottom_nav_marketplace: "Marketplace",
    bottom_nav_messages: "Messages",
    bottom_nav_profile: "Profil",
    
    // Hero Section
    hero_subtitle: "Services au Luxembourg",
    hero_title: "LëtzServices",
    hero_tagline: "Trouvez un service près de chez vous",
    hero_description: "La plateforme luxembourgeoise qui met en relation les personnes ayant besoin de services et les prestataires de confiance à prix raisonnable.",
    hero_cta: "Créer un compte",
    hero_secondary_cta: "Voir les annonces",
    hero_free: "Gratuit",
    hero_verified: "Vérifié",
    hero_local: "Local",
    
    // LëtzVerkafen (Marketplace)
    marketplace_title: "LëtzVerkafen",
    marketplace_subtitle: "Achetez et vendez au Luxembourg",
    marketplace_create: "Vendre un objet",
    marketplace_filter_all: "Tout",
    marketplace_filter_available: "Disponible",
    marketplace_filter_sold: "Vendu",
    marketplace_search: "Rechercher un produit...",
    marketplace_no_results: "Aucun produit trouvé",
    marketplace_negotiable: "Prix négociable",
    marketplace_condition: "État",
    marketplace_condition_neuf: "Neuf",
    marketplace_condition_comme_neuf: "Comme neuf",
    marketplace_condition_bon_etat: "Bon état",
    marketplace_condition_etat_correct: "État correct",
    marketplace_status_available: "Disponible",
    marketplace_status_sold: "Vendu",
    marketplace_status_reserved: "Réservé",
    marketplace_mark_sold: "Marquer vendu",
    marketplace_contact_seller: "Contacter le vendeur",
    marketplace_my_products: "Mes produits",
    marketplace_photo_required: "Au moins 1 photo requise",
    marketplace_add_photos: "Ajouter des photos",
    marketplace_upload_photo: "Télécharger une photo",
    
    // Create product
    create_product_title: "Vendre un objet",
    create_product_name: "Nom du produit",
    create_product_name_placeholder: "Ex: iPhone 14, Table IKEA, Vélo...",
    create_product_category: "Catégorie",
    create_product_category_placeholder: "Ex: Électronique, Meubles, Sport...",
    create_product_condition: "État du produit",
    create_product_price: "Prix (€)",
    create_product_price_placeholder: "Ex: 50, 100, 250...",
    create_product_negotiable: "Prix négociable",
    create_product_description: "Description",
    create_product_description_placeholder: "Décrivez votre produit en détail (état, dimensions, raison de vente...)",
    create_product_submit: "Publier l'annonce",
    create_product_photos: "Photos du produit",
    create_product_photos_hint: "Ajoutez jusqu'à 10 photos de votre produit.",
    create_product_add_more: "Ajouter plus de photos",
    
    // LëtzVerkafen Landing Section
    verkafen_section_title: "Marketplace",
    verkafen_section_heading: "LëtzVerkafen",
    verkafen_section_description: "Notre marketplace intégrée pour vendre et acheter des produits au Luxembourg. Publiez vos objets en quelques clics et trouvez de bonnes affaires près de chez vous.",
    verkafen_feature1: "Vente locale",
    verkafen_feature1_desc: "Vendez à des acheteurs près de chez vous",
    verkafen_feature2: "Photos multiples",
    verkafen_feature2_desc: "Jusqu'à 10 photos par annonce",
    verkafen_feature3: "Messagerie intégrée",
    verkafen_feature3_desc: "Contactez vendeurs et acheteurs facilement",
    verkafen_cta: "Découvrir la marketplace",
    
    // Delete actions
    delete_post: "Supprimer",
    delete_post_confirm: "Êtes-vous sûr de vouloir supprimer cette annonce ?",
    delete_review: "Supprimer",
    delete_review_confirm: "Êtes-vous sûr de vouloir supprimer cet avis ?",
    deleted_success: "Supprimé avec succès",
    
    // Email Auth
    auth_title: "Connexion",
    auth_register_title: "Inscription",
    auth_email: "Email",
    auth_email_placeholder: "votre@email.com",
    auth_password: "Mot de passe",
    auth_password_placeholder: "Min. 8 caractères + 1 spécial (!@#...)",
    auth_name: "Nom complet",
    auth_name_placeholder: "Votre nom",
    auth_login_btn: "Se connecter",
    auth_register_btn: "S'inscrire",
    auth_or: "ou",
    auth_google: "Continuer avec Google",
    auth_no_account: "Pas de compte ?",
    auth_has_account: "Déjà un compte ?",
    auth_create_account: "Créer un compte",
    auth_login_link: "Se connecter",
    auth_verify_title: "Vérification email",
    auth_verify_desc: "Un code a été envoyé à",
    auth_verify_code: "Code de vérification",
    auth_verify_code_placeholder: "123456",
    auth_verify_btn: "Vérifier",
    auth_resend_code: "Renvoyer le code",
    auth_wrong_credentials: "Email ou mot de passe incorrect",
    auth_email_exists: "Cet email est déjà utilisé",
    auth_password_too_short: "Le mot de passe doit faire au moins 6 caractères",
    
    // Services icons
    service_bricolage: "Bricolage",
    service_bricolage_desc: "Petits travaux",
    service_menage: "Ménage",
    service_menage_desc: "Nettoyage",
    service_demenagement: "Déménagement",
    service_demenagement_desc: "Transport",
    service_auto: "Auto",
    service_auto_desc: "Diagnostic",
    
    // About Section
    about_title: "À propos",
    about_heading: "Des services accessibles au Luxembourg",
    about_p1: "Au Luxembourg, le coût de la vie est souvent élevé, et il peut être difficile de trouver des services à prix raisonnable.",
    about_p2: "permet de trouver facilement des solutions plus accessibles, grâce à un réseau de personnes fiables, souvent proches de chez vous.",
    about_p3: "C'est une nouvelle façon de fonctionner, basée sur le",
    about_word_of_mouth: "bouche-à-oreille moderne",
    
    // About features
    about_network: "Réseau local",
    about_network_desc: "Prestataires près de chez vous",
    about_trust: "Confiance",
    about_trust_desc: "Avis vérifiés",
    about_price: "Prix accessibles",
    about_price_desc: "Tarifs raisonnables en €",
    
    // How it works
    how_title: "Fonctionnement",
    how_heading: "Comment ça marche ?",
    how_step1_title: "Créez votre compte",
    how_step1_desc: "Inscrivez-vous gratuitement via Google ou Facebook.",
    how_step2_title: "Publiez une annonce",
    how_step2_desc: "Demandez un service ou proposez vos compétences.",
    how_step3_title: "Consultez les annonces",
    how_step3_desc: "Parcourez les demandes et offres près de chez vous.",
    how_step4_title: "Échangez par messages",
    how_step4_desc: "Contactez les utilisateurs via la messagerie interne.",
    how_step5_title: "Réalisez la prestation",
    how_step5_desc: "Convenez des détails et effectuez le service.",
    how_step6_title: "Laissez un avis",
    how_step6_desc: "Notez et commentez pour aider la communauté.",
    
    // Services Section
    services_title: "Tous services",
    services_heading: "Tous les services sont possibles",
    services_description: "Publiez n'importe quelle demande ou offre de service. Pas de catégorie imposée !",
    services_examples: [
      "Bricolage et petits travaux",
      "Aide ménagère et nettoyage",
      "Aide au déménagement",
      "Transport (aéroport, courses...)",
      "Jardinage et extérieur",
      "Informatique et tech",
      "Garde d'animaux",
      "Cours particuliers",
      "Et bien plus encore..."
    ],
    
    // Why choose us
    why_title: "Nos avantages",
    why_heading: "Pourquoi choisir LëtzServices ?",
    why_price: "Prix accessibles",
    why_price_desc: "Des tarifs raisonnables pour tous les budgets.",
    why_fast: "Mise en relation rapide",
    why_fast_desc: "Trouvez un prestataire en quelques heures.",
    why_local: "Réseau local",
    why_local_desc: "Des prestataires proches de chez vous.",
    why_simple: "Simple et efficace",
    why_simple_desc: "Une plateforme intuitive et facile qui regroupe tout ce dont on a besoin.",
    why_reviews: "Système d'avis",
    why_reviews_desc: "Des retours authentiques pour choisir en confiance.",
    
    // Become provider
    provider_title: "Rejoignez-nous",
    provider_heading: "Devenez prestataire LëtzServices",
    provider_description: "Vous êtes bricoleur, indépendant ou passionné ? Proposez vos compétences et trouvez des clients près de chez vous au Luxembourg.",
    provider_benefit1: "Trouvez des missions régulières",
    provider_benefit2: "Fixez vos propres tarifs",
    provider_benefit3: "Gérez votre emploi du temps",
    provider_benefit4: "Développez votre réputation",
    provider_cta: "Devenir prestataire",
    provider_members: "Membres actifs",
    provider_free: "Gratuit",
    provider_fast: "Rapide",
    
    // Signup popup
    popup_title: "Rejoignez LëtzServices !",
    popup_description: "Créez votre compte gratuitement pour publier des annonces et contacter les prestataires près de chez vous au Luxembourg.",
    popup_cta: "Créer mon compte gratuit",
    popup_later: "Plus tard",
    popup_free: "100% Gratuit",
    popup_secure: "Sécurisé",
    
    // Posts page
    posts_title: "Annonces",
    posts_subtitle: "Trouvez ou proposez des services au Luxembourg",
    posts_create: "Publier une annonce",
    posts_filter_all: "Tout",
    posts_filter_demande: "Demandes",
    posts_filter_offre: "Offres",
    posts_search_ville: "Rechercher par ville...",
    posts_no_results: "Aucune annonce trouvée",
    posts_type_recherche: "Recherche",
    posts_type_propose: "Propose",
    
    // Create post
    create_title: "Publier une annonce",
    create_type_label: "Type d'annonce",
    create_type_recherche: "Je recherche",
    create_type_recherche_desc: "un service",
    create_type_propose: "Je propose",
    create_type_propose_desc: "mes services",
    create_title_label: "Titre de l'annonce",
    create_title_placeholder: "Ex: Recherche aide pour déménagement, Propose service de ménage...",
    create_ville_label: "Ville",
    create_ville_placeholder: "Ex: Luxembourg, Esch...",
    create_code_postal_label: "Code postal",
    create_code_postal_placeholder: "Ex: 1234, 4000...",
    create_price_label: "Prix (€)",
    create_price_placeholder: "Ex: 50, À discuter, Gratuit...",
    create_price_hint: "Le symbole € sera ajouté automatiquement",
    create_description_label: "Description détaillée",
    create_description_placeholder: "Décrivez votre besoin ou vos services en détail...",
    create_submit: "Publier l'annonce",
    
    // Dashboard
    dashboard_title: "Tableau de bord",
    dashboard_welcome: "Bienvenue,",
    dashboard_new_post: "Nouvelle annonce",
    dashboard_my_posts: "Mes annonces",
    dashboard_no_posts: "Vous n'avez pas encore d'annonces",
    dashboard_create_first: "Créer ma première annonce",
    dashboard_rating: "Note moyenne",
    dashboard_reviews: "Avis reçus",
    dashboard_status_active: "Active",
    dashboard_status_completed: "Terminée",
    dashboard_status_cancelled: "Annulée",
    dashboard_mark_completed: "Terminée",
    dashboard_view: "Voir",
    
    // Messages
    messages_title: "Messages",
    messages_no_messages: "Pas de messages pour le moment",
    messages_start_conv: "Contactez un membre depuis une annonce pour commencer",
    messages_new: "Nouveau message",
    messages_send: "Envoyer",
    messages_placeholder: "Votre message...",
    
    // Profile
    profile_edit: "Modifier",
    profile_cancel: "Annuler",
    profile_save: "Enregistrer",
    profile_member_since: "Membre depuis",
    profile_reviews_received: "Avis reçus",
    profile_name: "Nom",
    profile_bio: "Bio",
    profile_bio_placeholder: "Parlez de vous...",
    profile_ville: "Ville",
    profile_ville_placeholder: "Luxembourg...",
    profile_phone: "Téléphone",
    profile_phone_placeholder: "+352...",
    profile_upload_photo: "Changer la photo",
    profile_view_posts: "Voir les annonces",
    profile_contact: "Contacter",
    
    // Footer
    footer_description: "La plateforme de mise en relation entre particuliers et prestataires de services au Luxembourg.",
    footer_navigation: "Navigation",
    footer_services: "Services",
    footer_rights: "Tous droits réservés.",
    
    // Common
    back: "Retour",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    contact: "Contacter",
    
    // Conversation
    start_conversation: "Commencez la conversation",
    message_placeholder: "Votre message...",
    new_message_title: "Nouveau message",
    new_message_placeholder: "Écrivez votre message...",
    send: "Envoyer",
    reviews_received_title: "Avis reçus",
  },
  
  en: {
    // Navigation
    nav_announcements: "Listings",
    nav_how_it_works: "How it works",
    nav_services: "Services",
    nav_marketplace: "LëtzVerkafen",
    nav_dashboard: "Dashboard",
    nav_messages: "Messages",
    nav_login: "Login",
    nav_create_account: "Create account",
    nav_logout: "Logout",
    nav_profile: "My profile",
    nav_view_profile: "View my profile",
    nav_favorites: "Favorites",
    nav_pending_ratings: "Pending ratings",
    nav_create_post: "Create a listing",
    nav_menu: "Menu",
    bottom_nav_home: "Home",
    bottom_nav_listings: "Listings",
    bottom_nav_create: "Create",
    bottom_nav_marketplace: "Marketplace",
    bottom_nav_messages: "Messages",
    bottom_nav_profile: "Profile",
    
    // Hero Section
    hero_subtitle: "Services in Luxembourg",
    hero_title: "LëtzServices",
    hero_tagline: "Find a service near you",
    hero_description: "The Luxembourg platform connecting people who need services with trusted providers at reasonable prices.",
    hero_cta: "Create account",
    hero_secondary_cta: "View listings",
    hero_free: "Free",
    hero_verified: "Verified",
    hero_local: "Local",
    
    // LëtzVerkafen (Marketplace)
    marketplace_title: "LëtzVerkafen",
    marketplace_subtitle: "Buy and sell in Luxembourg",
    marketplace_create: "Sell an item",
    marketplace_filter_all: "All",
    marketplace_filter_available: "Available",
    marketplace_filter_sold: "Sold",
    marketplace_search: "Search for a product...",
    marketplace_no_results: "No products found",
    marketplace_negotiable: "Price negotiable",
    marketplace_condition: "Condition",
    marketplace_condition_neuf: "New",
    marketplace_condition_comme_neuf: "Like new",
    marketplace_condition_bon_etat: "Good condition",
    marketplace_condition_etat_correct: "Fair condition",
    marketplace_status_available: "Available",
    marketplace_status_sold: "Sold",
    marketplace_status_reserved: "Reserved",
    marketplace_mark_sold: "Mark as sold",
    marketplace_contact_seller: "Contact seller",
    marketplace_my_products: "My products",
    marketplace_photo_required: "At least 1 photo required",
    marketplace_add_photos: "Add photos",
    marketplace_upload_photo: "Upload a photo",
    
    // Create product
    create_product_title: "Sell an item",
    create_product_name: "Product name",
    create_product_name_placeholder: "Ex: iPhone 14, IKEA Table, Bike...",
    create_product_category: "Category",
    create_product_category_placeholder: "Ex: Electronics, Furniture, Sports...",
    create_product_condition: "Product condition",
    create_product_price: "Price (€)",
    create_product_price_placeholder: "Ex: 50, 100, 250...",
    create_product_negotiable: "Price negotiable",
    create_product_description: "Description",
    create_product_description_placeholder: "Describe your product in detail (condition, dimensions, reason for selling...)",
    create_product_submit: "Post listing",
    create_product_photos: "Product photos",
    create_product_photos_hint: "Add up to 10 photos of your product.",
    create_product_add_more: "Add more photos",
    
    // LëtzVerkafen Landing Section
    verkafen_section_title: "Marketplace",
    verkafen_section_heading: "LëtzVerkafen",
    verkafen_section_description: "Our integrated marketplace to buy and sell products in Luxembourg. Post your items in a few clicks and find great deals near you.",
    verkafen_feature1: "Local selling",
    verkafen_feature1_desc: "Sell to buyers near you",
    verkafen_feature2: "Multiple photos",
    verkafen_feature2_desc: "Up to 10 photos per listing",
    verkafen_feature3: "Integrated messaging",
    verkafen_feature3_desc: "Contact sellers and buyers easily",
    verkafen_cta: "Discover the marketplace",
    
    // Delete actions
    delete_post: "Delete",
    delete_post_confirm: "Are you sure you want to delete this listing?",
    delete_review: "Delete",
    delete_review_confirm: "Are you sure you want to delete this review?",
    deleted_success: "Successfully deleted",
    
    // Email Auth
    auth_title: "Login",
    auth_register_title: "Sign up",
    auth_email: "Email",
    auth_email_placeholder: "your@email.com",
    auth_password: "Password",
    auth_password_placeholder: "Min. 8 chars + 1 special (!@#...)",
    auth_name: "Full name",
    auth_name_placeholder: "Your name",
    auth_login_btn: "Login",
    auth_register_btn: "Sign up",
    auth_or: "or",
    auth_google: "Continue with Google",
    auth_no_account: "No account?",
    auth_has_account: "Already have an account?",
    auth_create_account: "Create account",
    auth_login_link: "Login",
    auth_verify_title: "Email verification",
    auth_verify_desc: "A code was sent to",
    auth_verify_code: "Verification code",
    auth_verify_code_placeholder: "123456",
    auth_verify_btn: "Verify",
    auth_resend_code: "Resend code",
    auth_wrong_credentials: "Invalid email or password",
    auth_email_exists: "This email is already in use",
    auth_password_too_short: "Password must be at least 6 characters",
    
    // Services icons
    service_bricolage: "DIY",
    service_bricolage_desc: "Small jobs",
    service_menage: "Cleaning",
    service_menage_desc: "Housekeeping",
    service_demenagement: "Moving",
    service_demenagement_desc: "Transport",
    service_auto: "Auto",
    service_auto_desc: "Diagnostic",
    
    // About Section
    about_title: "About",
    about_heading: "Accessible services in Luxembourg",
    about_p1: "In Luxembourg, the cost of living is often high, and it can be difficult to find services at reasonable prices.",
    about_p2: "makes it easy to find more accessible solutions, thanks to a network of reliable people, often close to you.",
    about_p3: "It's a new way of doing things, based on",
    about_word_of_mouth: "modern word-of-mouth",
    
    // About features
    about_network: "Local network",
    about_network_desc: "Providers near you",
    about_trust: "Trust",
    about_trust_desc: "Verified reviews",
    about_price: "Accessible prices",
    about_price_desc: "Reasonable rates in €",
    
    // How it works
    how_title: "How it works",
    how_heading: "How does it work?",
    how_step1_title: "Create your account",
    how_step1_desc: "Sign up for free via Google or Facebook.",
    how_step2_title: "Post a listing",
    how_step2_desc: "Request a service or offer your skills.",
    how_step3_title: "Browse listings",
    how_step3_desc: "Explore requests and offers near you.",
    how_step4_title: "Chat via messages",
    how_step4_desc: "Contact users via internal messaging.",
    how_step5_title: "Complete the service",
    how_step5_desc: "Agree on details and perform the service.",
    how_step6_title: "Leave a review",
    how_step6_desc: "Rate and comment to help the community.",
    
    // Services Section
    services_title: "All services",
    services_heading: "All services are possible",
    services_description: "Post any service request or offer. No imposed category!",
    services_examples: [
      "DIY and small jobs",
      "Housekeeping and cleaning",
      "Moving help",
      "Transport (airport, errands...)",
      "Gardening and outdoor",
      "IT and tech",
      "Pet sitting",
      "Private lessons",
      "And much more..."
    ],
    
    // Why choose us
    why_title: "Our advantages",
    why_heading: "Why choose LëtzServices?",
    why_price: "Accessible prices",
    why_price_desc: "Reasonable rates for all budgets.",
    why_fast: "Fast connection",
    why_fast_desc: "Find a provider in just hours.",
    why_local: "Local network",
    why_local_desc: "Providers close to you.",
    why_simple: "Simple and effective",
    why_simple_desc: "An intuitive and easy platform that brings together everything you need.",
    why_reviews: "Review system",
    why_reviews_desc: "Authentic feedback to choose with confidence.",
    
    // Become provider
    provider_title: "Join us",
    provider_heading: "Become a LëtzServices provider",
    provider_description: "Are you a handyman, freelancer or enthusiast? Offer your skills and find clients near you in Luxembourg.",
    provider_benefit1: "Find regular jobs",
    provider_benefit2: "Set your own rates",
    provider_benefit3: "Manage your schedule",
    provider_benefit4: "Build your reputation",
    provider_cta: "Become a provider",
    provider_members: "Active members",
    provider_free: "Free",
    provider_fast: "Fast",
    
    // Signup popup
    popup_title: "Join LëtzServices!",
    popup_description: "Create your free account to post listings and contact providers near you in Luxembourg.",
    popup_cta: "Create my free account",
    popup_later: "Later",
    popup_free: "100% Free",
    popup_secure: "Secure",
    
    // Posts page
    posts_title: "Listings",
    posts_subtitle: "Find or offer services in Luxembourg",
    posts_create: "Post a listing",
    posts_filter_all: "All",
    posts_filter_demande: "Requests",
    posts_filter_offre: "Offers",
    posts_search_ville: "Search by city...",
    posts_no_results: "No listings found",
    posts_type_recherche: "Looking for",
    posts_type_propose: "Offering",
    
    // Create post
    create_title: "Post a listing",
    create_type_label: "Listing type",
    create_type_recherche: "I'm looking for",
    create_type_recherche_desc: "a service",
    create_type_propose: "I'm offering",
    create_type_propose_desc: "my services",
    create_title_label: "Listing title",
    create_title_placeholder: "Ex: Looking for moving help, Offering cleaning service...",
    create_ville_label: "City",
    create_ville_placeholder: "Ex: Luxembourg, Esch...",
    create_code_postal_label: "Postal code",
    create_code_postal_placeholder: "Ex: 1234, 4000...",
    create_price_label: "Price (€)",
    create_price_placeholder: "Ex: 50, Negotiable, Free...",
    create_price_hint: "The € symbol will be added automatically",
    create_description_label: "Detailed description",
    create_description_placeholder: "Describe your need or services in detail...",
    create_submit: "Post listing",
    
    // Dashboard
    dashboard_title: "Dashboard",
    dashboard_welcome: "Welcome,",
    dashboard_new_post: "New listing",
    dashboard_my_posts: "My listings",
    dashboard_no_posts: "You don't have any listings yet",
    dashboard_create_first: "Create my first listing",
    dashboard_rating: "Average rating",
    dashboard_reviews: "Reviews received",
    dashboard_status_active: "Active",
    dashboard_status_completed: "Completed",
    dashboard_status_cancelled: "Cancelled",
    dashboard_mark_completed: "Completed",
    dashboard_view: "View",
    
    // Messages
    messages_title: "Messages",
    messages_no_messages: "No messages yet",
    messages_start_conv: "Contact a member from a listing to start",
    messages_new: "New message",
    messages_send: "Send",
    messages_placeholder: "Your message...",
    
    // Profile
    profile_edit: "Edit",
    profile_cancel: "Cancel",
    profile_save: "Save",
    profile_member_since: "Member since",
    profile_reviews_received: "Reviews received",
    profile_name: "Name",
    profile_bio: "Bio",
    profile_bio_placeholder: "Tell us about yourself...",
    profile_ville: "City",
    profile_ville_placeholder: "Luxembourg...",
    profile_phone: "Phone",
    profile_phone_placeholder: "+352...",
    profile_upload_photo: "Change photo",
    profile_view_posts: "View listings",
    profile_contact: "Contact",
    
    // Footer
    footer_description: "The platform connecting individuals and service providers in Luxembourg.",
    footer_navigation: "Navigation",
    footer_services: "Services",
    footer_rights: "All rights reserved.",
    
    // Common
    back: "Back",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    contact: "Contact",
    
    // Conversation
    start_conversation: "Start the conversation",
    message_placeholder: "Your message...",
    new_message_title: "New message",
    new_message_placeholder: "Write your message...",
    send: "Send",
    reviews_received_title: "Reviews received",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.fr[key] || key;
};
